<template>
  <v-img
    v-if="objectURL"
    contain
    :src="objectURL"
    :alt="altText"
    max-width="340"
    class="no-flow"
  ></v-img>
</template>

<script>

export default {
  name: 'DeviceCardImage',
  data() {
    return {
      objectURL: null,
    };
  },
  props: {
    image: {
      type: Object,
      required: true,
    },
  },
  watch: {
    image(newval/* , oldval */) {
      this.$authorizedFetch(newval.url)
        .then((response) => response.blob())
        .then((myBlob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.objectURL = reader.result;
          };
          reader.readAsDataURL(myBlob); // converts the blob to base64 and calls onload
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
  computed: {
    altText() {
      return `Thumbnail ${this.image.created}`;
    },
  },
  mounted() {
    this.$authorizedFetch(this.image.url)
      .then((response) => response.blob())
      .then((myBlob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.objectURL = reader.result;
        };
        reader.readAsDataURL(myBlob); // converts the blob to base64 and calls onload
      })
      .catch((e) => {
        console.error(e);
      });
  },
};
</script>
<style scoped>
.no-flow {
  overflow: hidden;
}
</style>
